import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { STPackageBundle } from '../billing/STPackageBundle.js';
import { Checkoutable } from './Checkoutable.js';
/**
 * Checkout flow between organizations
 */
export class PackagePurchases extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.packageBundles = [];
        /**
         * Renew existing packages
         */
        this.renewPackageIds = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(new EnumDecoder(STPackageBundle)) })
], PackagePurchases.prototype, "packageBundles", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], PackagePurchases.prototype, "renewPackageIds", void 0);
export class PackageCheckout extends Checkoutable {
}
__decorate([
    field({ decoder: PackagePurchases })
], PackageCheckout.prototype, "purchases", void 0);
//# sourceMappingURL=PackageCheckout.js.map